<template>
  <div id="app" class="app">
    <Top></Top>
    <main class="main-container" :class="{ 'with-padding': needTopPadding }">
      <router-view v-if="isRouterAlive"></router-view>
    </main>
    <Bottom></Bottom>
  </div>
</template>

<script>
var _hmt = _hmt || [];
(function() {
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?3925da53de2684afb634e1b8f9a84127";
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();

import Top from './components/Header.vue';
import Bottom from './components/Footer.vue';

export default {
  name: 'App',
  components: { Top, Bottom },
  provide() {
    return { reload: this.reload };
  },
  data() {
    return {
      isRouterAlive: true,
      fullscreenRoutes: ['/login'] // 只有登录页不需要顶部padding
    }
  },
  computed: {
    needTopPadding() {
      return !this.fullscreenRoutes.includes(this.$route.path);
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        if (this.fullscreenRoutes.includes(path)) {
          document.body.classList.add('is-fullscreen-page');
        } else {
          document.body.classList.remove('is-fullscreen-page');
        }
      }
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
}
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  position: relative;
  font-family: '微软雅黑', 'Microsoft YaHei', sans-serif !important;
  margin: 0;
  padding: 0;
  /* 关键修改：设置与导航条一致的深色背景，解决60px白边问题 */
  background-color: #0f1118;
  color: #fff;
  /* 全局文字设为白色，确保在深色背景上可见 */
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

/* 应用根容器 */
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #0f1118;
  /* 确保整页都是深色背景 */
}

/* 主内容区域 */
.main-container {
  flex: 1;
  position: relative;
  padding-top: 0;
  transition: padding-top 0.3s ease;
  /* 继承深色背景，确保padding区域也是深色 */
  background-color: inherit;
}

/* 需要padding的页面：60px深色区域与毛玻璃导航完美融合 */
.main-container.with-padding {
  padding-top: 60px;
  /* 可选：添加顶部微妙渐变，增强层次感 */
  background: linear-gradient(to bottom,
      rgba(15, 17, 24, 1) 0%,
      rgba(15, 17, 24, 1) 60px,
      rgba(15, 17, 24, 0.95) 60px,
      transparent 120px);
}

/* 全局滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(15, 17, 24, 0.8);
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.5);
}

/* 全屏页面（如登录页）特殊处理：导航条更透明 */
body.is-fullscreen-page .Top {
  background: linear-gradient(to bottom,
      rgba(15, 17, 24, 0.6) 0%,
      rgba(15, 17, 24, 0.3) 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

/* 登录页内容区域无需padding，背景可由登录页组件自行设置 */
body.is-fullscreen-page .main-container {
  padding-top: 0 !important;
  background: transparent;
  /* 登录页通常有自己的背景图 */
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-container.with-padding {
    padding-top: 60px;
    /* 移动端保持纯色背景更简洁 */
    background: #0f1118;
  }
}
</style>